import SectionInfo from './SectionInfo'
import SectionPrice from './SectionPrice'
import SectionForm from './SectionForm/PlaceBid'


/**
 * SectionCardUp component.
 *
 * Top section of the item details page showing:
 * - Item info (SectionInfo)
 * - Place bid form (SectionForm) if auction is active and not finalized
 * - Current price/bid info (SectionPrice)
 *
 * Handles auction timing logic: shows bid form only if auction hasn't ended
 * and reserve price has been met.
 *
 * @param {Object} props - Component props
 * @param {string} props.img1 - Owner avatar URL
 * @param {string} props.img2 - Unused
 * @param {Object} props.shit - Collection data
 * @param {Object} props.bidInfo - Bid information (unused)
 * @param {string|number} props.itemid - Token ID
 * @param {Object} props.ti - Token/item information with auctionData
 * @param {Function} props.rr - Refetch function
 * @returns {React.ReactElement} Upper card section with info and bidding
 */
function SectionCardUp({img1, img2, shit, bidInfo, itemid, ti, rr}) {


//console.log(["Hello", shit])
    //const shit = (value) => {
    //  instanceVariable.current = value; // make sure to use instanceVariable.current
    //}

    //const proccessVariable = () => {
    //   // Use instanceVariable.current and do some task
    // }
    return (
        <>
            <div className="col-12 mb-2 mt-2">
                <div className="pixel-card">
                    <div className="m-2">
                        <div className="row">

                            <SectionInfo img={img1} shit={shit} itemId={itemid} ti={ti} rr={rr}/>

                        </div>
                    </div>
                </div>
            </div>
            <div>{ti?.auctionData ?

                <div> {ti.auctionData.finalizeOnReserveMet !== true ?
                    <div> {(Math.floor(Date.now() / 1000)-ti.auctionData.finishTime) < 0 ?
                        <div className="col-12 mb-2">
                            <div className="pixel-card">
                                <div className="card-body p-3">
                                    <div className="row align-items-center">
                                        <SectionForm key="secForm" ti={ti} rr={rr}/>
                                        <SectionPrice key="secPrice" img={img2} bidInfo={bidInfo} ti={ti} rr={rr}/>

                                    </div>
                                </div>
                            </div>
                        </div>
                        : null} </div>
                    : null} </div>
                : null}
            </div>
        </>
    )
}

export default SectionCardUp
